import React, { useState } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './Projects.css';

//cafeteria imgs
import cafeteria0 from '../assets/Cafeteria/cafeteria0.jpg';
import cafeteria1 from '../assets/Cafeteria/cafeteria1.jpg';
import cafeteria2 from '../assets/Cafeteria/cafeteria2.jpg';
import cafeteria3 from '../assets/Cafeteria/cafeteria3.jpg';
import cafeteria4 from '../assets/Cafeteria/cafeteria4.jpg';
import cafeteria5 from '../assets/Cafeteria/cafeteria5.jpg';

//Domes imgs 
import Dome0 from '../assets/Domes/Dome0.jpg';
import Dome1 from '../assets/Domes/Dome1.jpg';
import Dome2 from '../assets/Domes/Dome2.jpg';
import Dome3 from '../assets/Domes/Dome3.jpg';
import Dome4 from '../assets/Domes/Dome4.jpg';
import Dome5 from '../assets/Domes/Dome5.jpg';

//tank images
 import tank0 from '../assets/Overhead tanks/tank0.jpg'
 import tank1 from '../assets/Overhead tanks/tank1.jpg'
 import tank2 from '../assets/Overhead tanks/tank2.jpg'
 import tank3 from '../assets/Overhead tanks/tank3.jpg'
 import tank4 from '../assets/Overhead tanks/tank4.jpg'
 import tank5 from '../assets/Overhead tanks/tank5.jpg'

//  import tank0 from '../assets/Overhead tanks/tank0.jpg'

//sites imgs
import site0 from '../assets/Residential/site0.jpg'
import site1 from '../assets/Residential/site1.jpg'
import site2 from '../assets/Residential/site2.jpg'
import site3 from '../assets/Residential/site3.jpg'
import site4 from '../assets/Residential/site4.jpg'
import site5 from '../assets/Residential/site5.jpg'
import site6 from '../assets/Residential/site6.jpg'
import site7 from '../assets/Residential/site7.jpg'
import site8 from '../assets/Residential/site8.jpg'
import site9 from '../assets/Residential/site9.jpg'
import site10 from '../assets/Residential/site10.jpg'
import site11 from '../assets/Residential/site11.jpg'


const Projects = () => {
  const [projects] = useState([
    {
      id: 1,
      name: 'Modern Cafeteria Complex',
      location: 'Delhi',
      description: 'A modern, well-planned cafeteria designed to serve residents with efficient food service, comfortable seating, and contemporary amenities.',
      images: [
        cafeteria0,
        cafeteria1,
        cafeteria2,
        cafeteria3,
        cafeteria4,
        cafeteria5,  
      ]
    },
    {
      id: 2,
      name: 'The Domes',
      location: 'Delhi',
      description: 'A reinforced concrete dome resting on a brick wall structure.',
      images: [
        Dome0,
        Dome1,
        Dome2,
        Dome3,
        Dome4,
        Dome5,
      ]
    },
    {
      id: 3,
      name: 'Overhead Tanks',
      location: 'Delhi',
      description: 'An elevated RCC water tank supported on columns, providing pressurized water supply to the building.',
      images: [
        tank0,
        tank1,
        tank2,
        tank3,
        tank4,
        tank5,
      ]
    },
    {
      id: 4,
      name: 'Residential & Commercial Sites',
      location: 'Delhi',
      description: 'A modern residential and commercial complex featuring living units along with shops, offices, and service areas, designed to provide convenient urban living.',
      images: [
        site0,
        site1,
        site2,
        site3,
        site4,
        site5,
        site6,
        site7,
        site8,
        site9,
        site10,
        site11,
      ]
    },
    // {
    //   id: 5,
    //   name: 'Healthcare Facility',
    //   location: 'Chennai, Tamil Nadu',
    //   description: 'Modern multi-specialty hospital with 200 beds and advanced medical infrastructure.',
    //   images: [
    //     // Add your healthcare facility images here
    //     // Example: healthcare0, healthcare1, healthcare2, healthcare3, healthcare4
    //   ]
    // }
  ]);

  const [currentImageIndex, setCurrentImageIndex] = useState({});

  const IMAGES_PER_SLIDE = 3;

  const handlePrevImage = (projectId, totalImages) => {
    const maxSlides = Math.ceil(totalImages / IMAGES_PER_SLIDE);
    setCurrentImageIndex(prev => {
      const currentSlide = Math.floor((prev[projectId] || 0) / IMAGES_PER_SLIDE);
      const newSlide = (currentSlide - 1 + maxSlides) % maxSlides;
      return {
        ...prev,
        [projectId]: newSlide * IMAGES_PER_SLIDE
      };
    });
  };

  const handleNextImage = (projectId, totalImages) => {
    const maxSlides = Math.ceil(totalImages / IMAGES_PER_SLIDE);
    setCurrentImageIndex(prev => {
      const currentSlide = Math.floor((prev[projectId] || 0) / IMAGES_PER_SLIDE);
      const newSlide = (currentSlide + 1) % maxSlides;
      return {
        ...prev,
        [projectId]: newSlide * IMAGES_PER_SLIDE
      };
    });
  };

  return (
    <div className="projects-page">
      {/* Page Header */}
      <div className="page-header-projects">
        <div className="container">
          <h1>Our Projects</h1>
          <p>Explore our portfolio of exceptional construction projects</p>
        </div>
      </div>

      {/* Projects Grid */}
      <section className="section projects-section">
        <div className="container">
          <div className="projects-grid">
            {projects.map((project) => (
              <div key={project.id} className="project-card">
                {/* Project Header */}
                <div className="project-header">
                  <h3>{project.name}</h3>
                  <p className="project-location">
                    <i className="fas fa-map-marker-alt"></i> {project.location}
                  </p>
                  <p className="project-description">{project.description}</p>
                </div>

                {/* Project Images Carousel */}
                <div className="project-carousel-container">
                  <div className="carousel-slides">
                    {(() => {
                      const startIndex = currentImageIndex[project.id] || 0;
                      const visibleImages = project.images.slice(startIndex, startIndex + IMAGES_PER_SLIDE);
                      return visibleImages.map((image, index) => (
                        <div key={startIndex + index} className="carousel-slide">
                          <img src={image} alt={`${project.name} - Image ${startIndex + index + 1}`} />
                        </div>
                      ));
                    })()}
                  </div>

                  <div className="carousel-controls">
                    <button 
                      className="carousel-button prev-button"
                      onClick={() => handlePrevImage(project.id, project.images.length)}
                      aria-label="Previous images"
                    >
                      <FaChevronLeft />
                    </button>
                    <button 
                      className="carousel-button next-button"
                      onClick={() => handleNextImage(project.id, project.images.length)}
                      aria-label="Next images"
                    >
                      <FaChevronRight />
                    </button>
                  </div>

                  {/* Slide indicators */}
                  <div className="carousel-indicators">
                    {(() => {
                      const totalSlides = Math.ceil(project.images.length / IMAGES_PER_SLIDE);
                      const currentSlide = Math.floor((currentImageIndex[project.id] || 0) / IMAGES_PER_SLIDE);
                      return Array.from({ length: totalSlides }).map((_, index) => (
                        <div
                          key={index}
                          className={`indicator-dot ${currentSlide === index ? 'active' : ''}`}
                          onClick={() => setCurrentImageIndex(prev => ({ ...prev, [project.id]: index * IMAGES_PER_SLIDE }))}
                          role="button"
                          tabIndex="0"
                          aria-label={`Go to slide ${index + 1}`}
                        ></div>
                      ));
                    })()}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects;
